<template>
  <v-container>
    <o-main-progress v-if="!loadedAll"/>
    <v-card v-else>
      <Cabecera 
        :tipoModuloActual="'listaInmuebles'"
        :incrustado="true"
      />
      <v-container fluid>
        <o-base-justify-text>
          <span v-html="getTexto('listaInmuebles.bienvenida', codigoPromocion)"/>
        </o-base-justify-text>
        <o-big-title>{{promocion.descripcion}}</o-big-title>
        <v-layout justify-center>
          <v-data-table
            style="width:100%"
            :headers="headersComputed"
            :items="inmuebles"
            :expand="$vuetify.breakpoint.mdAndDown"
            >
            <template slot="items" slot-scope="props">
              <tr :class="{ pointer: $vuetify.breakpoint.mdAndDown || props.item.inmueblesHijos.length > 0 }" @click="props.expanded = !props.expanded">
                <td style="width: 100%" class="text-xs-left pl-1 pr-1">
                  <v-layout row>
                    <!-- eslint-disable-next-line -->
                    {{(props.item.descripcionLarga != null ? props.item.descripcionLarga : '-') }}
                    <v-spacer/>
                    <v-icon 
                      v-if="$vuetify.breakpoint.mdAndDown || props.item.inmueblesHijos.length > 0" 
                      :style="props.expanded ? 'transform: rotate(-180deg)' : ''"
                    > 
                      keyboard_arrow_down 
                    </v-icon>
                  </v-layout>
                </td>
                <td class="text-xs-center hidden-xs-only">
                  <!-- eslint-disable-next-line -->
                  {{(props.item.m2Construidos != null ? props.item.m2Construidos : '-') | decimalInput}} m<sup>2</sup>
                </td>
                <td class="text-xs-center hidden-sm-and-down">
                  <!-- eslint-disable-next-line -->
                  {{(props.item.numDormitorios != null ? props.item.numDormitorios : '-')}}
                </td>
                <td class="text-xs-center hidden-md-and-down">
                  <!-- eslint-disable-next-line -->
                  {{(props.item.numBanios != null ? props.item.numBanios : '-')}}
                </td>
                <td class="pa-0" :class="$vuetify.breakpoint.xsOnly ? 'text-xs-left' : 'text-xs-center'">
                  {{props.item.precio | currency}}
                </td>
                <td class="text-xs-right pa-0">
                  <v-tooltip bottom>
                    <v-btn
                      icon flat
                      @click="creaReserva(props.item)"
                      slot="activator"
                    >
                      <v-icon color="primary"> arrow_forward </v-icon>
                    </v-btn>
                    <span>{{$t('pages.incrustado.reservarInmueble')}}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-if="$vuetify.breakpoint.mdAndDown || props.item.inmueblesHijos.length > 0" slot="expand" slot-scope="props">
              <v-list dense>
                <v-list-tile v-if="$vuetify.breakpoint.mdAndDown">
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-icon color="primary" slot="activator">mdi-ruler-square</v-icon>
                      <span>{{$t('pages.incrustado.metrosConstruidos')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <!-- eslint-disable-next-line -->
                      {{(props.item.m2Construidos != null ? props.item.m2Construidos : '-') | decimalInput}} m<sup>2</sup>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="$vuetify.breakpoint.mdAndDown">
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-icon color="primary" slot="activator">mdi-hotel</v-icon>
                      <span>{{$t('pages.incrustado.numDormitorios')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="(props.item.numDormitorios != null ? props.item.numDormitorios : '-') + $t('pages.incrustado.dormitorios')"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="$vuetify.breakpoint.mdAndDown">
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-icon color="primary" slot="activator">mdi-shower</v-icon>
                      <span>{{$t('pages.incrustado.numBanos')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="(props.item.numBanios != null ? props.item.numBanios : '-') + $t('pages.incrustado.banos')"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-for="(inmuebleHijo, index) in props.item.inmueblesHijos"
                  :key="'inmueblesHijos'+index"
                >
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-icon color="primary" slot="activator">mdi-home-city</v-icon>
                      <span>{{$t('pages.incrustado.numBanos')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-layout row align-center>
                      <v-flex class="list-text-overflow">
                      {{inmuebleHijo.descripcionLarga}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </template>
          </v-data-table>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {incrustado} from '@/mixins/incrustado'
import Cabecera from '@/components/Cabecera'

export default {
  components: {
    Cabecera
  },
  mixins: [incrustado],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      getAllInmuebles: 'promociones/inmuebles/getAll',
      codigoPromocion: 'incrustado/codigoPromocion',
      promocion: 'promociones/getActual'
    }),
    headers () {
      return [
        { text: this.$t('pages.incrustado.descripcion'), value: 'descripcionLarga', align: 'left', sortable: true, class: 'pl-1 pr-1' },
        { text: this.$t('pages.incrustado.metrosConstruidosHeader'), value: 'm2Construidos', align: 'center', sortable: true, class: 'hidden-xs-only' },
        { text: this.$t('pages.incrustado.numDormitorioHeader'), value: 'numDormitorios', align: 'center', sortable: true, class: 'hidden-sm-and-down' },
        { text: this.$t('pages.incrustado.numBanosHeader'), value: 'numBanios', align: 'center', sortable: true, class: 'hidden-md-and-down' },
        { text: this.$t('pages.incrustado.precio'), value: 'precio', align: 'center', sortable: true, class: '' },
        { text: this.$t('pages.incrustado.reservar'), value: 'accion', align: 'right', sortable: false, class: 'pa-0' }
      ]
    },
    soyAlquiler () {
      return this.$route.name.endsWith('listaInmueblesAlquiler')
    },
    inmuebles () {
      return this.getAllInmuebles.map(x => {
        return {
          id: x.id,
          descripcionLarga: x.descripcionLarga,
          m2Construidos: x.m2Construidos,
          numDormitorios: x.numDormitorios,
          numBanios: x.numBanios,
          precio: x.tarifa_importeTotal,
          codigoActivo: x.codigoActivo,
          inmueblesHijos: x.inmueblesHijos.map(x => {
            return {...x}
          })
        }
      })
    },
    headersComputed () {
      let copia = this.headers.map(h => {
        return {...h}
      })
      if (this.$vuetify.breakpoint.xsOnly) {
        let precio = copia.find(h => h.value === 'precio')
        precio.align = 'left'
        precio.class = 'pa-0'
      }
      return copia
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadInmueblesNoReservados: 'promociones/inmuebles/loadInmueblesNoReservados',
      setCodigoActivo: 'incrustado/codigoActivo',
      loadPromocion: 'promociones/loadPromocion'
    }),
    async initialize () {
      try {
        await Promise.all([
          this.loadInmueblesNoReservados({codigoPromocion: this.codigoPromocion, alquiler: this.soyAlquiler}),
          this.loadPromocion(this.codigoPromocion)
        ])
        return true
      } catch (error) {
        this.$router.push({name: 'incrustado.mensajeError'})
        return false
      }
    },
    creaReserva (inmueble) {
      this.setCodigoActivo(inmueble.codigoActivo)
      if (this.soyAlquiler) {
        this.$router.push({name: 'incrustado.condicionesAlquiler'})
      } else {
        this.$router.push({name: 'incrustado.condiciones'})
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/incrustado/listaInmuebles.vue